export const PAYEE_VERIFICATION_STATUS = {
  NOT_REQUIRED: 'not_required',
  BUSINESS_REQUIRED: 'business_required',
  INDIVIDUAL_REQUIRED: 'individual_required',
  UNDER_REVIEW: 'under_review',
  VERIFIED: 'verified',
  FAILED: 'failed',
};

export const VERIFIED_STATUSES = [
  PAYEE_VERIFICATION_STATUS.NOT_REQUIRED,
  PAYEE_VERIFICATION_STATUS.VERIFIED,
];


export const REQUIRED_STATUSES = [
  PAYEE_VERIFICATION_STATUS.BUSINESS_REQUIRED,
  PAYEE_VERIFICATION_STATUS.INDIVIDUAL_REQUIRED,
];
